export default "__VITE_ASSET__D$MaQz6v__"